/**
 * Report toolbar slot — cho phép mỗi dashboard "bắn" header (filter + reload) của
 * nó lên 1 block chung phía trên tabs của ReportsPage (giống PageHeader của
 * SaleContractPage). Dashboard giữ NGUYÊN state/query/preference; chỉ đổi chỗ
 * RENDER của header.
 *
 * - ReportsPage cung cấp `container` (1 <div> trong header chung) qua Provider.
 * - Dashboard bọc header bằng <ReportPageToolbar>: nếu có container → portal lên
 *   block chung; nếu KHÔNG (chạy standalone) → render inline như cũ.
 */
import { createContext, useContext, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

const ReportToolbarContext = createContext<HTMLElement | null>(null)

export function ReportToolbarProvider({
  container,
  children,
}: {
  container: HTMLElement | null
  children: ReactNode
}) {
  return <ReportToolbarContext.Provider value={container}>{children}</ReportToolbarContext.Provider>
}

export function ReportPageToolbar({ children }: { children: ReactNode }) {
  const container = useContext(ReportToolbarContext)
  if (container) return createPortal(children, container)
  return <>{children}</>
}
